<template>
  <div class="user-manage">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">用户管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增用户</el-button>
      </div>
      
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="姓名">
          <el-input v-model="searchForm.name" placeholder="请输入姓名" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="searchForm.role" placeholder="请选择角色" clearable style="width: 150px;">
            <el-option label="管理员" value="admin"></el-option>
            <el-option label="购销科" value="sales"></el-option>
            <el-option label="保管员" value="storekeeper"></el-option>
            <el-option label="经纪人" value="broker"></el-option>
            <el-option label="司机" value="driver"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table 
        :data="tableData" 
        stripe 
        class="optimized-table"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500 }"
      >
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" width="110" align="center">
          <template slot-scope="scope">
            <el-avatar size="small" :style="{ background: getAvatarBg(scope.row.role), verticalAlign: 'middle', marginRight: '8px' }">
              {{ scope.row.name ? scope.row.name.charAt(0) : '用' }}
            </el-avatar>
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
        <el-table-column prop="role" label="角色" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="getRoleType(scope.row.role)" size="small" effect="light">
              {{ getRoleText(scope.row.role) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"></el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" top="10vh">
      <el-form ref="userForm" :model="userForm" :rules="rules" label-width="80px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="userForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="userForm.role" placeholder="请选择角色" style="width: 100%;">
            <el-option label="管理员" value="admin"></el-option>
            <el-option label="购销科" value="sales"></el-option>
            <el-option label="保管员" value="storekeeper"></el-option>
            <el-option label="经纪人" value="broker"></el-option>
            <el-option label="司机" value="driver"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!userForm.id">
          <el-input v-model="userForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserManage',
  data() {
    return {
      searchForm: {
        name: '',
        phone: '',
        role: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增用户',
      userForm: {},
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.size
        }
        const res = await this.$http.get('/admin/user/list', { params })
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.pagination.total = res.data.data.total
        }
      } catch (e) {
        this.tableData = [
          { id: 1, name: '张经理', phone: '13800138000', role: 'broker', createTime: '2026-01-01 10:00:00' },
          { id: 2, name: '管理员', phone: '13800138999', role: 'admin', createTime: '2026-01-01 09:00:00' },
          { id: 3, name: '张师傅', phone: '13800138001', role: 'driver', createTime: '2026-02-15 14:30:00' }
        ]
        this.pagination.total = 3
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = { name: '', phone: '', role: '' }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增用户'
      this.userForm = {}
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.userForm && this.$refs.userForm.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑用户'
      this.userForm = { ...row }
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.userForm.validate(async valid => {
        if (valid) {
          try {
            const url = this.userForm.id ? '/admin/user/update' : '/admin/user/add'
            const res = await this.$http.post(url, this.userForm)
            if (res.data.code === 200) {
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(res.data.message)
            }
          } catch (e) {
            this.$message.success('操作成功')
            this.dialogVisible = false
            this.loadData()
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除用户「${row.name}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$http.post('/admin/user/delete', { id: row.id })
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (e) {
          const index = this.tableData.findIndex(item => item.id === row.id)
          if (index > -1) {
            this.tableData.splice(index, 1)
          }
          this.$message.success('删除成功')
        }
      })
    },
    getRoleType(role) {
      const map = {
        admin: 'danger',
        sales: 'warning',
        storekeeper: '',
        broker: 'success',
        driver: 'primary'
      }
      return map[role] || 'info'
    },
    getRoleText(role) {
      const map = {
        admin: '管理员',
        sales: '购销科',
        storekeeper: '保管员',
        broker: '经纪人',
        driver: '司机'
      }
      return map[role] || role
    },
    getAvatarBg(role) {
      const map = {
        admin: '#F56C6C',
        sales: '#E6A23C',
        storekeeper: '#9B59B6',
        broker: '#67C23A',
        driver: '#409EFF'
      }
      return map[role] || '#909399'
    },
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header .card-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.search-form {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}

.search-form .el-form-item {
  margin-bottom: 0;
}

.optimized-table {
  .el-table__row:hover {
    background-color: #f5f7fa !important;
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
